import React, { useState } from "react";
import ReactDOM from "react-dom";

interface ConfirmModalProps<T> {
  title: string;
  Content: React.ComponentType<{ onChange: (data: T) => void }>;
  onConfirm: (data: T | null) => void;
  onCancel: () => void;
}

export function ConfirmModal<T>({ title, Content, onConfirm, onCancel }: ConfirmModalProps<T>) {
  const [data, setData] = useState<T | null>(null);

  return ReactDOM.createPortal(
    <div className="fixed inset-0 flex items-center justify-center bg-black min-w-lg bg-opacity-50 z-50">
      <div className="bg-white p-6 rounded-lg shadow-md w-1/3 min-w-lg">
        <h2 className="text-lg font-bold mb-4">{title}</h2>
        <Content onChange={setData} />
        <div className="flex justify-end mt-4">
          <button className="px-4 py-2 bg-gray-300 rounded mr-2" onClick={onCancel}>
            Cancel
          </button>
          <button
            className="px-4 py-2 bg-green-500 text-white rounded disabled:bg-gray-500"
            onClick={() => onConfirm(data)}
            disabled={!(data && Object.keys(data).length)}
          >
            Confirm
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
}
